import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formModes, UserContext } from '../../constants';
import { Svg } from '../Svg';
import i18next from "../../i18n";
export class DocumentInfo extends Component {
    static contextType = UserContext;
    static propTypes = {
        creatorInfo: PropTypes.object,
        performerInfo: PropTypes.object,
        created: PropTypes.string,
        state: PropTypes.string,
        states: PropTypes.array,
        formMode: PropTypes.string
    };
    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
        this.clickEvent = this.clickEvent.bind(this);
    }
    clickEvent(e) {
        let targetId = e.target.id;
        if (targetId !== 'status-item-btn' && !this.hasParent(e.target, 'status-item-btn') && targetId !== 'about-doc-info' && !this.hasParent(e.target, 'about-doc-info'))
            this.setState({ show: false });
    }
    componentDidMount() {
        document.addEventListener("click", this.clickEvent);
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.clickEvent);
    }
    hasParent(element, id) {
        while (element.parentElement) {
            if (element.parentElement.id === id)
                return true;
            element = element.parentElement;
        }
        return false;
    }
    render() {
        const { creatorInfo, performerInfo, created, state, states, formMode } = this.props;
        let info = {
            date: "",
            status: "",
            author: "",
            performer: ""
        };
        info.status = states?.find(obj => obj.Value === state)?.Label;
        if (formMode === formModes.create) {
            let user = this.context;
            info.author = user ? `${user.userName ? user.userName : ""}${user.position ? ', ' + user.position : ""}` : "";
            info.performer = info.author;
        }
        else {
            info.author = creatorInfo ? `${creatorInfo.creatorFullName ? creatorInfo.creatorFullName : ""}${creatorInfo.creatorPosition ? ', ' + creatorInfo.creatorPosition : ""}` : "";
            info.performer = performerInfo ? `${performerInfo.fullName ? performerInfo.fullName : ""}${performerInfo.position ? ', ' + performerInfo.position : ""}` : "";
            const date = new Date(created);
            info.date = `${date.toLocaleDateString("uk-UA")} ${date.toLocaleTimeString("uk-UA").substring(0, 5)}`;
        }
        let ul = [
            { src: "/img/info.svg", key: "form.documentInfo.documentInformation" },
            { src: "/img/icon-person.svg", key: "form.documentInfo.author", value: info?.author && <label className="info-content-label">{info.author}</label> },
            { src: "/img/icon-person.svg", key: "form.documentInfo.performer", value: info?.performer && <label className="info-content-label">{info.performer}</label> },
            { src: "/img/location.svg", key: "form.documentInfo.status", value: info?.status && <label className="status-r">{info.status}</label> }
        ]
        if (formMode === formModes.create) ul.push({ src: "/img/clock.svg", key: "form.documentInfo.dateCreation", value: info?.date && <label className="info-content-label">{info.date}</label> });
        return (
            <li className="status-item">
                <div className="status-item-btn" id="status-item-btn" onClick={() => this.setState({ show: !this.state.show })}>
                    <Svg src="/img/info.svg" />
                    <label>{i18next.t("form.documentInfo.aboutDocument")}</label>
                </div>
                {this.state.show &&
                    <div className="about-doc-info" id="about-doc-info">
                        <ul>
                            <li>
                                <Svg src="/img/info.svg" />
                                <label>{i18next.t("form.documentInfo.documentInformation")}</label>
                            </li>
                            {ul.map((item, index) => item?.value ? <li key={index}>
                                <Svg src={item.src} />
                                {item?.value && <label>{i18next.t(item.key)}</label>}
                                {item.value}
                            </li> : "")}
                        </ul>
                    </div>
                }
            </li>
        );
    }
}